import React from 'react';
import PropTypes from 'prop-types';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from 'views/components';

import {Translate} from 'views/module';

const ConfirmResetModal = (props) => {
  const {
    closeModal,
    onClickConfirm,
  } = props;

  return (
    <Dialog onClose={closeModal}>
      <DialogTitle onClose={closeModal}>
        <Translate expression='generic.ConfirmTheAction'/>
      </DialogTitle>
      <DialogContent>
        <Typography>
          <Translate expression='generic.ResetConfirm'/>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={closeModal}>
          <Translate expression='generic.Cancel'/>
        </Button>
        <Button onClick={onClickConfirm}>
          <Translate expression='generic.Confirm'/>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
ConfirmResetModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
};

export default React.memo(ConfirmResetModal);
